import {Dispatch, FC, createContext, useContext, useEffect, useState} from 'react'
import {WithChildren} from '../../../_metronic/helpers'
import {getCompanyById} from '../../services/companies'

const IS_PRODUCTION = process.env.ENV === 'PRODUCTION'
// const URL_LOGOUT = IS_PRODUCTION ? (process.env.REACT_APP_LOGOUT ?? '') : ''
const URL_LOGOUT = ''

type AuthContextProps = {
  urlApi: string
  setUrlApi: Dispatch<string>
  urlLogout: string
  setUrlLogout: Dispatch<string>
  selectedCompanyId: string | undefined
  setSelectedCompanyId: Dispatch<string>
  selectedPoliticaYPrivacidad: boolean
  setSelectedPoliticaYPrivacidad: Dispatch<boolean>
  selectedRole: string | undefined
  setSelectedRole: Dispatch<string>
  userData: any
  setUserData: Dispatch<any>
  isCompanySelectorModalOpen: boolean
  setCompanySelectorModalStatus: Dispatch<boolean>
  isPoliticaYPrivacidadSelectorModalOpen: boolean
  setPoliticaYPrivacidadSelectorModalStatus: Dispatch<boolean>
  idEmpresaInterna: string
  filtroHistorico?: {idProceso: string; codUnidad: string; search: string}
  setFiltroHistorico?: (value: {idProceso: string; codUnidad: string; search: string}) => void
}

const getUserData = (): AuthContextProps => {
  const storedUrlApi = localStorage.getItem('urlApi') || ''
  const storedUrlLogout = localStorage.getItem('urlLogout') || URL_LOGOUT
  const storedSelectedCompanyId = localStorage.getItem('selectedCompanyId') || undefined
  const storedSelectedPoliticaYPrivacidad = Boolean(
    localStorage.getItem('selectedPoliticaYPrivacidad')
  )
  const storedSelectedRole = localStorage.getItem('selectedRole') || undefined
  const storedUserData = JSON.parse(localStorage.getItem('userData') || '{}')
  const storedFiltroHistorico = JSON.parse(localStorage.getItem('filtroHistorico') || '{}')

  return {
    urlApi: storedUrlApi,
    setUrlApi: () => {},
    urlLogout: storedUrlLogout,
    setUrlLogout: () => {},
    selectedCompanyId: storedSelectedCompanyId,
    setSelectedCompanyId: () => {},
    selectedPoliticaYPrivacidad: storedSelectedPoliticaYPrivacidad,
    setSelectedPoliticaYPrivacidad: () => {},
    selectedRole: storedSelectedRole,
    setSelectedRole: () => {},
    userData: storedUserData,
    setUserData: () => {},
    isCompanySelectorModalOpen: false,
    setCompanySelectorModalStatus: () => {},
    isPoliticaYPrivacidadSelectorModalOpen: false,
    setPoliticaYPrivacidadSelectorModalStatus: () => {},
    idEmpresaInterna: '',
  }
}

const AuthContext = createContext<AuthContextProps>(getUserData())

const useAuth2 = () => {
  return useContext(AuthContext)
}

const Auth2Provider: FC<WithChildren> = ({children}) => {
  const [urlApi, setUrlApi] = useState<string>(() => getUserData().urlApi || '')
  const [urlLogout, setUrlLogout] = useState<string>(() => getUserData().urlLogout || '')
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>(
    () => getUserData().selectedCompanyId || ''
  )
  const [selectedPoliticaYPrivacidad, setSelectedPoliticaYPrivacidad] = useState<boolean>(
    () => Boolean(getUserData().selectedPoliticaYPrivacidad) || false
  )
  const [selectedRole, setSelectedRole] = useState<string>(() => getUserData().selectedRole || '')
  const [userData, setUserData] = useState<any>(() => getUserData().userData)
  const [isCompanySelectorModalOpen, setCompanySelectorModalStatus] = useState<boolean>(false)
  const [isPoliticaYPrivacidadSelectorModalOpen, setPoliticaYPrivacidadSelectorModalStatus] =
    useState<boolean>(false)
  const [idEmpresaInterna, setIdEmpresaInterna] = useState<string>('')

  useEffect(() => {
    localStorage.setItem('selectedCompanyId', selectedCompanyId)
    localStorage.setItem('selectedRole', selectedRole)
    localStorage.setItem('selectedRole', selectedRole)
    localStorage.setItem('selectedPoliticaPrivacidad', String(selectedPoliticaYPrivacidad))
    const terminoycondicion =
      userData.userTerminosYCondiciones === false ? [] : userData.userTerminosYCondiciones
    const existingUserData = getUserData().userData
    const updatedUserData = {
      ...existingUserData,
    }

    localStorage.setItem('userData', JSON.stringify(updatedUserData))

    if (userData?.userCompany?.length > 0) {
      if (userData.userCompany.length === 1) {
        setSelectedCompanyId(userData.userCompany[0].id)
      }

      if (userData.userRole.length === 1) {
        setSelectedRole(userData.userRole[0])
      }

      if (selectedCompanyId === '' || selectedRole === '') {
        setCompanySelectorModalStatus(true)
      } else {
        setCompanySelectorModalStatus(false)
      }

      if (selectedPoliticaYPrivacidad) {
        console.log("entro a privacidad")
        setPoliticaYPrivacidadSelectorModalStatus(true)
      } else {
        console.log("no entro a privacidad")
        setPoliticaYPrivacidadSelectorModalStatus(true)
        setPoliticaYPrivacidadSelectorModalStatus(false)
      }
    } else {
      if (userData?.userRole?.length === 1) {
        setSelectedRole(userData.userRole[0])
      }
    }
  }, [selectedCompanyId, selectedPoliticaYPrivacidad, selectedRole, userData])

  useEffect(() => {
    getCompanyById(selectedCompanyId ?? '').then((result) => {
      setIdEmpresaInterna(result?.data?.idEmpresaWorkin?.toString() ?? '')
    })
  }, [selectedCompanyId])

  return (
    <AuthContext.Provider
      value={{
        urlApi,
        setUrlApi,
        urlLogout,
        setUrlLogout,
        selectedCompanyId,
        setSelectedCompanyId,
        selectedPoliticaYPrivacidad,
        setSelectedPoliticaYPrivacidad,
        userData,
        setUserData,
        selectedRole,
        setSelectedRole,
        isCompanySelectorModalOpen,
        setCompanySelectorModalStatus,
        isPoliticaYPrivacidadSelectorModalOpen,
        setPoliticaYPrivacidadSelectorModalStatus,
        idEmpresaInterna,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export {Auth2Provider, useAuth2}
